import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              K-ALTERATIONS
            </Link>
            <p>Alterations for the right fitting</p>
          </div>
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><span onClick={() => scrollToSection('home')}>Home</span></li>
              <li><span onClick={() => scrollToSection('about')}>About</span></li>
              <li><Link to="/services">Services</Link></li>
              <li><span onClick={() => scrollToSection('contact')}>Contact</span></li>
            </ul>
          </div>
          <div className="footer-services">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services/wedding-dresses">Wedding Dress Alterations</Link></li>
              <li><Link to="/services/suits">Suit Tailoring</Link></li>
              <li><Link to="/services/pants">Pants Hemming</Link></li>
              <li><Link to="/services">View All Services</Link></li>
            </ul>
          </div>
          <div className="footer-contact">
            <h4>Contact Info</h4>
            <ul>
              <li>Located in the Janesville Mall</li>
              <li><i className="fas fa-map-marker-alt"></i> 2500 Milton Ave Suite #132 Janesville, WI 53545</li>
              <li><i className="fas fa-phone-alt"></i> (608) 741-4122</li>
            </ul>
          </div>
        </div>
       
      </div>
    </footer>
  );
}
